var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full flex"},[_c('p',{staticClass:"text-5xl m-auto"},[_vm._v(" Invalid Quote ")])])}]

export { render, staticRenderFns }